import $ from "jquery";

type JQueryElement = any; // JQuery<HTMLElement>;

export function initRealignMixin() {
  $(".re-align").each((idx: number, ele: any) => {
    const realign = $(ele);
    const question = realign.find(".question");
    const answer = question.next();

    answer.find(".move-up").on("click", (evt: any) => {
      const target = $(evt.currentTarget);
      const thisAnswer = target.closest(".answer");
      const nextAnswer = thisAnswer.parent().prev().prev().find(".answer");
      swap(thisAnswer, nextAnswer);
    });

    answer.find(".move-down").on("click", (evt: any) => {
      const target = $(evt.currentTarget);
      const thisAnswer = target.closest(".answer");
      const nextAnswer = thisAnswer.parent().next().next().find(".answer");
      swap(thisAnswer, nextAnswer);
    });

    function swap(thisAnswer: JQueryElement, nextAnswer: JQueryElement) {
      const src = thisAnswer.parent();
      const dst = nextAnswer.parent();
      src.append(nextAnswer);
      dst.append(thisAnswer);
      src.find("input").attr("value", nextAnswer.attr("value") || "");
      dst.find("input").attr("value", thisAnswer.attr("value") || "");
    }
  });
}

export function initReorderMixin() {
  const reorders = $(".reorder");

  reorders.find(".move-left").on("click", (evt: any) => {
    var target = $(evt.currentTarget);
    var thisWord = target.parent();
    var nextWord = thisWord.parent().prev().find(".word");
    console.log({
      thisWord: thisWord.attr("value"),
      nextWord: nextWord.attr("value"),
    });
    swap(target, thisWord, nextWord);
  });

  reorders.find(".move-right").on("click", (evt: any) => {
    var target = $(evt.currentTarget);
    var thisWord = target.parent();
    var nextWord = thisWord.parent().next().find(".word");
    swap(target, thisWord, nextWord);
  });

  function swap(
    target: JQueryElement,
    thisWord: JQueryElement,
    nextWord: JQueryElement
  ) {
    var src = thisWord.parent();
    var dst = nextWord.parent();
    src.append(nextWord);
    dst.append(thisWord);
    var order = "";
    target
      .closest(".reorder")
      .find(".word")
      .each((idx: number, element: any) => {
        order += $(element).attr("value");
      });
    console.log("order", order);
    target.closest(".reorder").find("input").attr("value", order);
  }
}
